<div class="select-domain" artemisThemeSwitcher>
  <div class="dashboard-header">
    <div class="log-out">
      <a class="log-out__arrow" (click)="logOut()">
        <img src="/assets/icons/arrow-left-icon.svg">
      </a>
      <span class="log-out__text" (click)="logOut()">Log out</span>
    </div>
    <div class="user-profile">
      <img class="themified-white-icon user-profile__profile-icon" src="/assets/icons/user-profile-icon.png"/>
      <span class="user_profile__text" [title]="(profileStore$ | async).user?.name">{{(profileStore$ | async).user?.name}}</span>
    </div>
  </div>
  <div class="select-domain__header">Select Domain</div>
  <ng-container *ngIf="domains | async as d">
    <div class="select-domain__container">
      <artemis-loading-spinner *ngIf="loading$ | async"></artemis-loading-spinner>
      <div *ngIf="d.length > 0 else emptyDomainList" class="select-domain__content">
        <mat-form-field class="custom-mat-form-field select-domain__list">
          <mat-label>DOMAIN</mat-label>
          <img matSuffix class="custom-mat-autocomplete__arrow-icon" src="/assets/icons/chevron-down-icon.png">
            <mat-select [(ngModel)]="domain">
              <mat-option *ngFor="let domain of d" [value]="domain" class="cust-mat-option">
                <span title="{{domain.domainName}}">{{domain.domainName}}</span>
              </mat-option>
            </mat-select>
        </mat-form-field>
        <div class="select-domain__button">
          <button class="btn_accent-gradient-rounded" ubi-round-button mat-button [disabled] = !domain (click)="chooseDomain()">Submit</button>
        </div>
      </div>
      <ng-template #emptyDomainList>
        <div class="select-domain__content">
          <mat-form-field class="custom-mat-form-field select-domain__list">
            <mat-label>DOMAIN</mat-label>
            <mat-select [disabled] = true [(ngModel)]="domain">
              <mat-option *ngFor="let domain of d" [value]="domain">
                {{domain.domainName}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="select-domain__button">
            <button class="btn_accent-gradient-rounded" ubi-round-button mat-button [disabled] = true (click)="chooseDomain()">Submit</button>
          </div>
        </div>
        <div class="select-domain__hint">No domain to select, please contact an administrator for more details.</div>
      </ng-template>
    </div>
  </ng-container>
</div>
